import { NextResponse } from "next/server";
import {
  ChatAppID,
  ChatRegion,
  ChatRestAPIKey,
} from "@/Utils/APIRequest/Endpoints";

export async function POST(req) {
  try {
    const { endpoint, data, action } = await req.json();

    if (action === "checkOrCreate") {
      // 1. Check if user exists
      const getUrl = `https://${ChatAppID}.api-${ChatRegion}.cometchat.io/v3/users/${data.uid}`;
      const getOptions = {
        method: "GET",
        headers: {
          accept: "application/json",
          apikey: ChatRestAPIKey,
        },
      };
      const getRes = await fetch(getUrl, getOptions);
      if (getRes.ok) {
        // User exists, return existing user (or just ok)
        const user = await getRes.json();
        return NextResponse.json({ data: user?.data, existed: true });
      }

      // 2. If not found, create
      const createUrl = `https://${ChatAppID}.api-${ChatRegion}.cometchat.io/v3/users`;
      const createOptions = {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
          apikey: ChatRestAPIKey,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(createUrl, createOptions)
        .then((res) => res.json())
        .then((json) => {
          return json?.data ? json?.data : json?.error;
        })
        .catch((err) => {
          return err;
        });
      return NextResponse.json({ data: response });
    }

    const url = `https://${ChatAppID}.api-${ChatRegion}.cometchat.io/v3/${endpoint}`;
    const options = {
      method: "POST",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        apikey: ChatRestAPIKey,
      },
      body: JSON.stringify({ ...data }),
    };
    const response = await fetch(url, options)
      .then((res) => res.json())
      .then((json) => {
        return json?.data ? json?.data : json?.error;
      })
      .catch((err) => {
        return err;
      });

    return NextResponse.json({ data: response });
  } catch (error) {
    console.error("Error during create user:", error);
    return NextResponse.json(
      { error: "Something went wrong" },
      { status: 500 }
    );
  }
}

export async function PUT(req) {
  try {
    const { endpoint, data } = await req.json();

    const url = `https://${ChatAppID}.api-${ChatRegion}.cometchat.io/v3/users/${endpoint}`;
    const options = {
      method: "PUT",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        apikey: ChatRestAPIKey,
      },
      body: JSON.stringify({ ...data }),
    };
    const response = await fetch(url, options)
      .then((res) => res.json())
      .then((json) => {
        return json?.data ? json?.data : json?.error;
      })
      .catch((err) => {
        return err;
      });

    return NextResponse.json({ data: response });
  } catch (error) {
    console.error("Error during create user:", error);
    return NextResponse.json(
      { error: "Something went wrong" },
      { status: 500 }
    );
  }
}
